import Client from './Client.js';

export default class Core {

    #modules;

    /**
     *
     * @param params
     */
    constructor(params = {}) {
        this.config = {
            baseURL: '',
            leadingSlash: false,
            trailingSlash: false,
            ...params
        };
        this.client = new Client(this.config);
        this.#modules = {};
    }

    /**
     *
     * @param object
     * @param entrypoints
     */
    init(entrypoints) {
        entrypoints.forEach(Item => {
            if (Item instanceof Function && Item.prototype.namespace) {
                this.#modules[Item.prototype.namespace] = new Item(this);
            }
        });
    }

    /**
     *
     * @returns {{}}
     */
    get generatedModules() {
        return this.#modules;
    }
}
